export default {
  notice: {
    progress: '{done} van {total} plekken gemarkeerd',
    participation_hint: 'Nog een paar stappen om je plekken af te ronden.',
    participation_unfinished: 'Je deelname is nog niet afgerond'
  },
  home_tiles: {
    preset_demo: 'Aanbevolen',
    preset_weide: 'Weide',
    preset_app: 'App',
    preset_speels: 'Speels',
    layout_game: 'Game',
    layout_poster: 'Poster',
    depth_demo: 'Diepte',
    depth_flat: 'Plat',
    depth_soft: 'Zacht',
    depth_deep: 'Diep',
    demo_panel: 'Demo-opties',
    notice_demo: 'Deelname-melding',
    notice_progress: 'Voortgang',
    notice_bold: 'Opvallend',
    notice_boldprogress: 'Opvallend + voortgang',
    notice_boldfull: 'Opvallend + tekst + voortgang',
    bg_demo: 'Achtergrond',
    bg_plain: 'Wit',
    bg_soft: 'Zacht',
    bg_meadow: 'Weide',
    banner_welcome: 'Welkom',
    layout_welcome: 'Welkom',
    welcome_intro: 'Je volgt {communities} communities en hebt {areas} gebieden gemarkeerd.',
    banner_demo: 'Header',
    banner_solid: 'Vlak',
    banner_photo: 'Foto',
    banner_minimal: 'Minimaal',
    banner_pass: 'Ledenpas',
    areas_count: '{count} gebieden',
    communities_count: '{count} communities',
    budget_line: '{amount} budget · {pct}% toegezegd',
    layout_demo: 'Tegel-layout',
    layout_inline: 'Inline',
    layout_icon: 'Icoon',
    layout_compact: 'Compact',
    subscribers: '{count} abonnees',
    hello: 'Hoi {name}',
    notifications: 'Meldingen',
    unread: '{count} ongelezen',
    all_read: 'Alles gelezen',
    no_messages: 'Nog geen berichten',
    see_all: 'Bekijk alles',
    budget: 'Budget',
    pledged: 'toegezegd',
    no_budget: 'Nog geen natuurbudget',
    no_areas: 'Nog geen gebieden. Markeer plekken die je belangrijk vindt op de kaart.',
    no_communities: 'Je volgt nog geen community.',
    browse_map: 'Bekijk de kaart'
  },
  theme: {
    title: 'Thema',
    modern_light: 'Licht',
    modern_dark: 'Donker',
    neon: 'Neon',
    glass: 'Glas'
  },
  messages: {
    // account_created: 'Please check your email to verify your registration. This sometimes can take up to 10 minutes. Please check the spam folder if the email has not been received.',
    // password_forgot: 'Please check your email to reset your password.',
    // verification_success: 'Your e-mail has been verified. You can now login.',
    // verification_failed: 'Verification has failed.',
    // password_recover_success: 'Your password has been reset. You can now login with the new password.',
    // logout_confirmation: 'Are you sure you want to log out?',
    // confirm: 'Confirm',
    // update_available: 'A new update is available. Click on ok to reload the page.',
    // account_signed_out: 'You have been signed out',
    // account_updated: 'Account succesfully updated'
    account_created: 'Account succesvol aangemaakt',
    password_forgot: 'Controlleer je e-mail voor het opnieuw instellen van je wachtwoord.',
    account_signed_out: 'Je bent succesvol uitgelogd',
    account_updated: 'Account succesvol aangepast',
    verification_success: 'Je e-mail is geverifieerd. Je kunt nu inloggen.',
    verification_failed: 'Verificatie is mislukt.',
    password_recover_success: 'Je wachtwoord is opnieuw ingesteld. Je kunt nu inloggen met je nieuwe wachtwoord.',
    logout_confirmation: 'Weet je zeker dat je uit wilt loggen?',
    login_confirmation: 'Je bent succesvol ingelogd. Welkom terug!',
    login_failed: 'E-mail en wachtwoord combinatie niet bekend',
    confirm: 'Bevestig',
    update_available: 'Een nieuwe update is beschikbaar. Klik op ok om de pagina te verversen.',
    url_copied_to_clipboard: 'De kaart url is gecopieerd naar het klembord',
    add_area_account_required: 'Om een gebied toe te kunnen voegen, heb je een account nodig.',
    area_deleted: 'Het gebied is verwijderd',
    area_updated: 'Het gebied is aangepast',
    unsubscribed: 'Je bent niet langer lid van deze community',
    subscribed: 'Je bent nu onderdeel van deze community',
    thread_created: 'Er is een nieuwe discussie gestart',
    thread_updated: 'De discussie is aangepast',
    comment_created: 'Je hebt content geplaatst',
    comment_reported: 'Deze content is gevlagd voor moderatie',
    comment_unreported: 'Deze content is vrijgegeven na moderatie',
    comment_deleted: 'Deze content is verwijderd',
    community_updated: 'Deze content is aangepast',
    RMS_send: 'Een moderator verzoek is verstuurd',
    poll_created: 'Poll aangemaakt',
    polis_created: 'Polis aangemaakt',
    meeting_created: 'Meeting aangemaakt',
    meeting_invite_accepted: 'Je hebt de uitnodiging geaccepteerd',
    meeting_invite_declined: 'Je hebt de uitnodiging geweigerd',
    pledge_funding_completed: 'Doneren succesvol afgerond',
    pledge_added: 'Bedankt voor je toezegging van € ',
    pledge_rejected: 'Dank voor uw uitleg'
  },
  errors: {
    general_error: 'Er is een fout opgetreden. Probeer het nogmaals.',
    not_found: 'Sorry, hier is niks...',
    network: 'Netwerk fout. Controleer je internet verbinding',
    // fields: 'Please correct the input fields',
    required: 'Verplicht veld',
    register: {
      password_length: 'De minimale lengte van het wachtwoord is {length} karakters.',
      password_match: 'De wachtwoorden komen niet overeen.',
      email_valid: 'Een geldig e-mail adres is vereist',
      name_length: 'Scherm naam lengte moet tussen {minLength} en {maxLength} karakters zijn',
      organization_length: 'Organisatienaam lengte moet tussen {minLength} en {maxLength} karakters zijn'
    }
  },
  buttons: {
    pledge: 'Toezeggen',
    ok: 'Ok',
    submit: 'Verstuur',
    logout: 'Log uit',
    cancel: 'Annuleren',
    login: 'Login',
    register: 'Registreer',
    // go_back: 'Go back',
    send: 'Verstuur',
    reSend: 'Verstuur opnieuw',
    close: 'Sluit',
    previous: 'Vorige',
    save: 'Opslaan',
    create: '',
    update: 'Update',
    delete: 'Verwijder',
    subscribe: 'Aanmelden',
    unsubscribe: 'Afmelden',
    next: 'Volgende',
    continue: 'Verder',
    back: 'Terug',
    add: 'Voeg toe',
    edit: 'Aanpassen',
    reply: 'Antwoorden',
    report: 'Melden',
    unreport: 'Melden annuleren',
    goto_authenticate: 'Naar login',
    stop: 'Stop',
    pauze: 'Pauzeren',
    continue_register: 'Verder met registratie',
    continue_participation: 'Doorgaan met participatie',
    become_moderator: 'Moderator worden',
    add_image: 'Plaatje toevoegen',
    accept: 'Accepteren',
    decline: 'Weigeren',
    reset: 'Reset',
    discard: 'Verwerpen'
  },
  headers: {
    login: 'Login',
    register: 'Registreren',
    password_forgot: 'Nieuw wachtwoord aanvragen',
    password_recover: 'Wachtwoord herstellen',
    administrator: 'Administrator',
    navigation: 'Navigatie',
    my_overview: 'Mijn overzicht',
    overview: 'Overzicht',
    users: 'Users',
    communities: 'Communities'
  },
  activities: {
    act_cycl: {
      title: 'Fietsen',
      desciption: 'TODO'
    },
    act_walk: {
      title: 'Wandelen of hardlopen',
      desciption: 'TODO'
    },
    act_tour: {
      title: 'Rondrijden met auto of motor',
      desciption: 'TODO'
    },
    act_natu: {
      title: 'Natuur observeren',
      desciption: 'TODO'
    },
    act_water: {
      title: 'Watersport',
      desciption: 'TODO'
    },
    act_play: {
      title: 'Spelen of zitten',
      desciption: 'TODO'
    },
    act_wintr: {
      title: 'Wintersport',
      desciption: 'TODO'
    },
    act_mount: {
      title: 'Bergsport',
      desciption: 'TODO'
    }
  },
  labels: {
    account_required: 'Account noodzakelijk',
    read_more: 'lees verder',
    'area_create_button': 'Opslaan',
    'area_update_button': 'Opslaan',
    'area_created_succes': 'Gebied succesvol aangemaakt',
    'area_updated_succes': 'Gebied succesvol aangepast',
    'community_created_succes': 'Community succesvol aangemaakt',
    agree_disclaimer: 'Ik ga akkoord met deze voorwaarden',
    my_account: 'Mijn account',
    register: 'Maak account aan',
    logout: 'Loguit',
    login: 'Login',
    email: 'E-mailadres',
    name: 'Scherm naam',
    companyName: 'Bedrijfsnaam',
    organization: 'Organisatienaam',
    sector: 'Sector',
    address: 'Adres',
    address_search: 'Woonplek',
    // zipcodeCompany: 'Zipcode headquarter',
    website: 'Web pagina',
    city: 'Woonplaats',
    // cityCompany: 'City headquarter',
    age: 'Leeftijdscategorie',
    education: 'Opleiding',
    gender: 'Geslacht',
    type: 'Type',
    password: 'Wachtwoord',
    repeat_password: 'Herhaal wachtwoord',
    remember_me: 'Onthoud mij',
    password_forgot: 'Wachtwoord vergeten?',
    home: 'Thuis',
    here: 'hier',
    neighbourhood: 'buurt',
    'living-area': 'regio',
    country: 'land',
    worldwide: 'wereldwijd',
    share_this_area: 'Deel dit gebied',
    share_this_community: 'Deel deze community',
    subscribed: 'Geabonneerd',
    reply: 'Antwoorden',
    comment: 'Commentaar',
    finish: 'Beeindigen',
    readmore: 'lees meer',
    search: 'zoek',
    created_on: 'aangemaakt op',
    dear: 'Beste',
    karma: 'Karma'
  },
  pages: {
    home: {
      title: 'Home'
    },
    moderators: {
      title: 'Moderators',
      mod_requests: 'Moderator verzoeken',
      mods: 'Moderators'
    },
    create_community: {
      title: 'Maak community'
    },
    land_owner_register: {
      title: 'Land-eigenaar registratie',
      steps: {
        general: {
          nav_title: 'Algemen info',
          title: 'Landeigenaar informatie',
          task_title: 'Geef enige algemene informatie over het land dat u bezit/beheert',
          email: 'E-mail'
        },
        draw: {
          nav_title: 'Kaart',
          title: 'Teken gebied',
          task_title: 'Teken uw gebied'
        },
        description: {
          nav_title: 'Omschrijving',
          title: 'Beschrijf uw community',
          task_title: 'Geef een titel die uw community beschrijft',
          input_title: 'Titel',
          input_title_error: 'Maximaal 50 karakters',
          input_description: 'Omschrijving',
          task_description: 'Beschrijf wat juist deze community aantrekkelijk, waardevol of belangrijk maakt',
          input_description_error: 'Maximaal 1000 karakters'
        },
        finalize: {
          nav_title: 'Afronden',
          title: 'Informatie',
          task_title: 'Dank voor het verstrekken van deze informatie, als u op Afronden klikt dan kunne nwe uw community aanmaken. Om te discussieren met uw community kunt u een discussie aanmaken. Kik op de 3 puntjes rechts van \'discussie\' om een nieuwe discussie aan te maken.'
        }
      }
    },
    pledge: {
      count: 'Aantal toezeggingen',
      part1: 'toegezegd van',
      part2: 'doel',
      question: 'Zou u iets willen <b>toezeggen</b> uit uw virtueel natuur budget voor dit project?',
      yes: 'Ja, ik <b>wil</b> iets toezeggen aan dit project',
      no: 'Nee, ik wil <b>niets</b> toezeggen aan dit project'
    },
    add_pledge: {
      title_nav: 'Toezeggen',
      title: 'Geef het bedrag aan dat u zou willen toezeggen voor het financieren van dit project.',
      amount: 'Bedrag',
      reason: 'Zou u alstublieft willen toelichten waarom u voor dit bedrag heeft gekozen?',
      reasonNo: 'Zou u alstublieft willen toelichten waarom u niet aan dit project wilt toezeggen?',
      confirm_text1: 'U stelt momenteel voor om',
      confirm_text2: 'van uw aangegeven jaarlijkse natuurbudget aan dit project toe te zeggen. Wilt u dit bedrag bevestigen?',
      confirm: 'Ik bevestig'
    },
    add_treasure: {
      title_nav: 'Maak treasure aan',
      photos: 'Fotos',
      title: 'Upload foto van treasures',
      description: 'Beschrijf waarom je deze plek mooi vindt. Deel een tekening, gedicht, afbeelding of een kort verhaal.',
      upload: 'Upload foto (.jpg)'
    },
    create_pledge: {
      title_nav: 'Maak toezegging aan',
      title: 'Beschrijf uw financieringsverzoek met een pakkende titel.',
      description: 'Beschrijf uw financieringsverzoek in meer detail. Geef achtergrondinformatie, voorgestelde acties, verwachte resultaten en wat uw donateurs ervoor terugkrijgen.',
      type: 'Pledge type',
      fixed: 'Vast',
      fixed_desc: 'Verzoek om eenmalige financiering',
      yearly: 'Jaarlijks',
      yearly_desc: 'Verzoek om jaarlijks terugkerende financiering',
      '2yearly': 'Per 2 jaar',
      '2yearly_desc': 'Verzoek om financiering die elke 2 jaar terugkeert',
      '3yearly': 'Per 3 jaar',
      '3yearly_desc': 'Verzoek om financiering die elke 3 jaar terugkeert',
      '4yearly': 'Per 4 jaar',
      '4yearly_desc': 'Verzoek om financiering die elke 4 jaar terugkeert',
      '5yearly': 'Per 5 jaar',
      '5yearly_desc': 'Verzoek om financiering die elke 5 jaar terugkeert',
      goal: 'Geef uw streefbedrag aan in euro\'s'
    },
    edit_pledge: {
      title_nav: 'Aanpassen pledge'
    },
    create_message: {
      title_nav: 'Create message',
      steps: {
        community: {
          nav_title: 'Community',
          title: 'Select the <b>community</b> to sent the message to its <b>all fans</b> ect</p>'
        },
        message: {
          nav_title: 'Message'
        },
        finalize: {
          nav_title: 'Finalize'
        }
      }
    },
    create_thread: {
      title_nav: 'Maak discussie aan',
      title_nav_edit: 'Pas discussie aan',
      title: 'Geef een titel',
      description: 'Geef eerste aanzet voor de discussie',
      options: 'Voeg poll opties toe',
      option: 'optie',
      upload: 'Upload fotos (.jpg)'
    },
    create_poll: {
      title_nav: 'Maak Poll aan',
      title_nav_edit: 'Pas Poll aan',
      title: 'Geef een titel',
      description: 'Geef eerste aanzet voor de discussie',
      upload: 'Upload fotos (.jpg)'
    },
    create_polis: {
      title_nav: 'Maak polis aan',
      title_nav_edit: 'Pas Polis aan',
      title: 'Geef een titel',
      id: 'Geef het polis ID op',
      voter_option: 'Alleen leden van de community kunnen stemmen'
    },
    create_meeting: {
      title_nav: 'Maak Bijeenkomst aan',
      title_nav_edit: 'Pas bijeenkomst aan',
      title: 'Geef een titel',
      description: 'Geef een omschrijving',
      url: 'Geef externe url van de online bijeenkomst',
      dateTime: 'Starttijd & datum'
    },
    meeting: {
      total_subs: 'Totaal aantal leden',
      accepted_invites: 'Geaccepteerde uitnodigingen',
      rejected_invites: 'Geweigerde uitnodigingen',
      planned_label: 'gepland op',
      invited_banner: 'Je bent uigenodigd voor deze meeting',
      accepted_banner: 'Je hebt de uitnodiging geaccepteerd, als je geselecteerd word ontvang je een e-mail met verdere details over de meeting.',
      rejected_banner: 'Je hebt de uitnodiging geweigerd',
      send_banner: 'Stuur de link voor de meeting naar de leden die de uitnodiging hebben geaccepteerd.',
      resend_banner: 'Stuur de link voor de meeting opnieuw. Let op: je hebt de url reeds verstuurd!'
    },
    landing: {
      my_portal: 'My Xena'
    },
    welcome: {
      title: 'Welkom bij Greenmapper',
      introduction: 'Introductie',
      subtitle_1: 'Markeer natuur- en landschapsplekken',
      paragraph_1: 'In Greenmapper Friends markeert u <b>natuur- of landschapsplekken</b> met <b>groen en/of water</b> die voor u <b>aantrekkelijk, waardevol of belangrijk</b> zijn. Een plek kan klein of groot zijn, in of buiten stad of dorp. U kunt er vaak komen, zelden komen of een plek vooral kennen van verhalen of foto’s.',
      subtitle_2: 'Waarom registreren?',
      paragraph_2: 'Elke gemarkeerde plek is een plek waar u een <b>online vriend</b> van kunt zijn. Daarom vragen we enkele gegevens om een account aan te maken. Alleen uw <b>schermnaam</b> is zichtbaar voor andere gebruikers.',
      subtitle_3: 'Privacy',
      paragraph_3: 'Greenmapper Friends is een initiatief van de Rijksuniversiteit Groningen. Uw e-mailadres wordt opgeslagen in de Greenmapper Landscape Friend Registry (GLFR) en is alleen toegankelijk voor de Greenmapper-organisatie. Via het platform kunnen landeigenaren, beheerders of andere vrienden u alleen anoniem bereiken; zij krijgen nooit direct toegang tot uw e-mailadres. We werken volgens AVG/GDPR.',
      continue_without_account: 'Doorgaan zonder account',
      login_text: 'Als je al een account hebt, kun je inloggen',
      forgot_password: 'Wachtwoord vergeten?',
      forgot_password_dialog: 'Geef je e-mailadres.'
    },
    introduction: {
      title: 'Introductie',
      text: 'In Greenmapper Friends kunt u <b>natuur- of landschapsplekken markeren </b> die u <b>aantrekkelijk, waardevol of belangrijk</b> vindt. Deze gebieden moeten plekken met groen, water of natuur zijn. U kunt denken aan een plek in een park, bij een meer, op zee, in een bos, een grasland, een bloemenveld of een plek om vogels te spotten. Het kan een plek zijn binnen of buiten een stad of dorp, klein of groot. U kunt deze plek vaak bezoeken, of misschien bijna nooit! Het gaat er om dat het de natuurplek voor u aantrekkelijk, waardevol of betekenisvol is.',
      start_btn: 'Start enquête'
    },
    register: {
      email_sublabel: 'niet zichtbaar voor anderen',
      name_sublabel: 'zichtbaar voor anderen',
      name_hint: 'bijvoorbeeld een bijnaam of voornaam',
      address_search_sublabel: '±200 m bij uw huis is genoeg',
      password_hint: 'minimaal 8 karakters',
      map_preview_hint: 'Selecteer een woonlocatie om deze op de kaart te zien',
      use_my_location: 'Gebruik mijn locatie',
      geolocate_failed: 'Kon je locatie niet bepalen. Controleer de rechten of zoek handmatig.',
      location_not_found: 'Geen locatie gevonden. Probeer een plaats, adres of postcode.',
      disclaimer_title: 'Disclaimer Greenmapper Friends',
      disclaimer: 'Greenmapper Friends slaat je e-mailadres op in het Greenmapper Landscape Friend Registry (GLFR).Niemand heeft toegang tot dit e-mailadres behalve Greenmapper Friends. Via het GLFR kun je anoniem worden benaderd door landeigenaren, landbeheerorganisaties of andere vrienden van het gebied. Deze derden hebben echter geen directe toegang tot je e-mailadres of persoonlijke gegevens. We vragen ook om je thuislocatie. Dit is een locatie bij benadering: het gaat om de straat of buurt waar je woont. Je geeft dit aan op de kaart; je precieze adres is niet nodig! We volgen de richtlijnen van de Europese Algemene Verordening Gegevensbescherming (AVG) voor privacy en het opslaan van je persoonlijke gegevens. Lees meer details'
    },
    info_contact: {
      title: 'Over ons',
      contact: 'Contact',
      disclaimer_title: 'Disclaimer',
      implementation: 'Implementatie: '
    },
    map: {
      title: 'Algemene community kaart',
      add_btn: 'Teken een nieuw gebied',
      share_title: 'Deel kaart url',
      share_btn: 'Kopieer naar klembord',
      hint_on_add: 'Plaats de stip op de kaart om te starten met tekenen',
      hint_on_end_draw: 'Je kunt het gebied nog steeds aanpassen.',
      zoom_to_area_btn: 'Zoom in naar het gebied',
      details_btn: 'Bekijk details' // share_desc: 'Share'

    },
    timeline: {
      title: 'Tijdlijn',
      hint: 'Wist je dat de meest populaire activiteit op favoriete natural plekken wandelen is?',
      rating: 'Waardering',
      rating_subtext: 'Persoonlijke waardering van het gemarkeerde gebied',
      visit_frequency: 'Bezoekfrequentie',
      visit_frequency_subtext: 'Hoe vaak bezoek je het gebied`',
      activities: 'Activiteiten',
      activities_subtext: 'Activiteiten gemeld bij gemarkeerde gebied',
      add_btn: 'Voeg gebied toe',
      edit_btn: 'Pas gebied aan',
      delete_btn: 'Verwijder gebied',
      delete_title: 'Verwijder gebied',
      delete_subtitle: 'Weet je het zeker?'
    },
    add_area_info: {
      title: 'Voeg een gebied toe',
      add_btn: 'Voeg gebied toe'
    },
    my_areas: {
      title: 'Mijn gebieden',
      sub_title: 'Alle natuurlijke plekken die ik aantrekkelijk, waardevol of belangrijk vind.',
      created_areas: 'Gemarkeerde gebieden',
      joint_surface: 'Totaal oppervlak (km2)',
      and_section_eyebrow: 'Greenmapper Database Aantrekkelijke Natuur',
      and_section_title: 'Je vier favoriete plekken op schaal',
      and_complete_badge: 'Alle vier schalen compleet',
      free_section_title: 'Plekken die je zelf hebt toegevoegd'
    },
    my_communities: {
      title: 'Mijn communities',
      sub_title: 'Alle gebieden van landeigenaren of landbeheerders die overlappen met mijn gebieden. Hier ben je bereikbaar als vriend van die gebieden.',
      delete_btn: 'Afmelden',
      delete_title: 'Afmelden',
      delete_subtitle: 'Weet je zeker dat je je wilt afmelden voor deze community?',
      befriended_communities: 'Bevriende communities',
      joint_surface: 'Totaal oppervlak (km2)'
    },
    info: {
      text1: 'Greenmapper Friends wordt ontwikkeld door Greenmapper. Voor meer informatie kijk op Greenmapper.org',
      text2: 'Als je vragen hebt of in contact wilt komen met ons, stuur dan een e-mail naar: info@greenmapper.org',
      text3: 'We proberen de Greenmapper Friends applicatie en data accuraat en vrij van fouten te houden. Als je -ondanks onze inspanningen- incomplete of inacurate informatie tegenkomt, dan kunnen we daar geen verantwoordelijkheid voor nemen.',
      text4: 'We houden het recht voor om aanpassingen, het verwijderen of toevoegen van materiaal aan de inhoud van de applicatie te doen zonder waarschuwing vooraf. Greenmapper Friends accepteert geen aansprakelijkheid voor informatie op websites waarnaar wij verwijzen via hyperlinks.'
    },
    my_owned_communities: {
      title: 'Mijn communities',
      owned_communities: 'Communities',
      total_subs: 'Totaal aantal leden',
      joint_surface: 'Totaal oppervlak (km2)'
    },
    community: {
      report_title: 'Melden commentaar',
      report_subtitle: 'Weet je zeker dat je dit commentaar wilt melden voor moderatie?',
      report_hint: 'Geef een reden',
      delete_title: 'Verwijder commentaar',
      delete_subtitle: 'Weet je zeker dat je dit commentaar wilt verwijderen?',
      discussions_title: 'Discussies',
      discussions_subtitle: 'Open discussies over elk onderwerp',
      poll_title: 'Poll',
      poll_subtitle: 'Simpele opiniepeiling',
      polis_title: 'Pol.is',
      polis_subtitle: 'Klik op het onderstaande onderwerp om pol.is-peiling te starten',
      pledges_title: 'Steun projecten!',
      pledges_subtitle: 'Virtuele toezegging van geld voor biodiversiteit, landschapskwaliteit of duurzame diensten',
      meetings_title: 'Meetings',
      meetings_subtitle: 'Diepgaande online workshop of vergadering van vrienden',
      RMS_dialog_title: 'Verzoek moderator status',
      RMS_dialog_text: 'Wil je een verzoek versturen om moderator voor deze community te worden?'
    },
    polis: {
      text: 'Voor elke stelling kun je ‘Akkoord’, ‘Niet akkoord’, of ‘Onzeker’ stemmen.',
      text2: 'Stuur jouw mening in, zodat anderen op jouw idee kunnen stemmen.'
    },
    account: {
      edit_title: 'Pas profiel aan',
      edit_text: 'Pas je huidige profiel informatie aan',
      edit_btn: 'Pas profiel aan',
      signout_title: 'Log uit',
      signout_text: 'Uitloggen van je account',
      signout_btn: 'Log uit'
    },
    set_home: {
      title: 'Woonplek',
      popup_title: 'Waar woont u?',
      popup_text: 'Versleep de pin in de buurt van je huis (±200 m)'
    },
    create_area: {
      title: 'Gebied aanmaken',
      add_title: 'Gebied toevoegen',
      home_title: 'Plaats thuis marker',
      pauze_title: 'Weet u het zeker?',
      pauze_text: 'Pauzeer registratie en maak later af',
      map_tips: 'Kaarttips',
      search_place: 'Zoek een plek',
      search_not_found: 'Niets gevonden',
      zoom_smaller: 'Kleiner',
      zoom_bigger: 'Groter',
      area_reset: 'Gebied gereset',
      reset_polygon: 'Polygoon resetten',
      reset_polygon_title: 'Polygoon resetten?',
      reset_polygon_text: 'Hiermee zet je de polygoon terug naar hoe deze eruitzag voordat je ging bewerken.',
      leave_polygon_edit_title: 'Polygoonbewerkingen verlaten?',
      leave_polygon_edit_text: 'Als je teruggaat, wordt de polygoon weer de cirkelselectie. Je puntbewerkingen gaan verloren.',
      polygon_guard: {
        cross: 'Lijnen mogen elkaar niet kruisen',
        spacing: 'Punten mogen niet te dicht bij elkaar',
        edge: 'Punt mag niet te dicht bij een andere zijde',
        angle: 'Hoek mag niet zo scherp worden',
        area: 'Gebied mag niet zo klein worden',
        bounds: 'Punt blijft binnen het zichtbare kaartgebied'
      },
      loading: {
        title: 'Kaart voorbereiden',
        opening: 'Kaart openen…',
        loading_account: 'Account laden…',
        loading_areas: 'Jouw gebieden laden…',
        loading_home: 'Woonplek laden…'
      },
      hints: {
        place_above_area: 'Plaats over je gebied',
        place_area_here: 'Plek volledig erin',
        drag_vertex: 'Sleep punten voor betere pasvorm',
        zoom: 'Zoom in en uit',
        at_edge: 'Je hebt de rand van dit gebied bereikt'
      },
      stepper: {
        description: 'Omschrijving',
        rate: 'Beoordeling',
        visit_freq: 'Bezoekfrequentie',
        activities: 'Activiteiten',
        connected: 'Online verbonden'
      },
      steps: {
        level: {
          nav_title: 'Niveau',
          title: 'Kies niveau',
          task_title: 'Kies niveau van het gebied',
          options: {
            neighborhood: 'buurt / lokaal',
            living_area: 'regio / regionaal',
            country: 'land',
            world: 'wereld'
          }
        },
        map: {
          nav_title: 'Kaart',
          title: 'Teken gebied',
          task_title: 'Teken je gebied'
        },
        description: {
          nav_title: 'Omschrijving',
          title: 'Omschrijving',
          task_title: 'Hoe noem jij dit gebied?',
          input_title: 'Titel',
          input_name: 'Naam',
          input_title_error: 'Maximaal 50 karakters',
          input_description: 'Omschrijving',
          task_description: 'Waarom is dit gebied aantrekkelijk, waardevol en/of belangrijk?',
          input_description_error: 'Maximaal 1000 karakters'
        },
        rate: {
          nav_title: 'Beoordeling',
          title: 'Waardeer je gebied',
          task_title: '(Score: 1 = slecht, 6 = gemiddeld, 10 = perfect)'
        },
        visit_freq: {
          nav_title: 'Bezoekfrequentie',
          title: 'Hoe vaak bezoek je jouw gebied?',
          options: {
            daily: 'Dagelijks',
            weekly: 'Wekelijks',
            monthly: 'Maandelijks',
            few_times_a_year: 'Paar keer per jaar',
            yearly: 'Jaarlijks',
            rarely: 'Soms',
            never: 'Nooit'
          }
        },
        activities: {
          nav_title: 'Activiteiten',
          title: 'Welke activiteiten doe je zoal in dit gebied?'
        },
        priority: {
          nav_title: 'Prioriteit',
          title: 'Deze plek zou moeten worden:',
          options: {
            maintained: 'Behouden (= zo laten als het is)',
            strengthened: 'Versterkt (= verbeteren)'
          }
        },

        /* relationship: {
            nav_title: 'Relatie',
            title: 'Wat is uw relatie met dit favoriete natuurgebied?',
            options: {
                tourist: 'Toerist',
                inhabitant: 'Inwoner',
                work: 'Werkgerelateerd'
            }
        }, */

        /* finished: {
            '1_title': 'Dank je! Je eerste plek staat op de kaart',
            '1_text': 'Alleen al deze bijdrage helpt beter begrijpen welke natuurgebieden mensen waarderen. Je kunt nu een volgende plek toevoegen, of later terugkomen (via de knop rechtsboven).',
            '2_title': 'Mooi — je persoonlijke kaart begint vorm te krijgen',
            '2_text': 'Met elke plek help je beter zichtbaar maken wat bescherming verdient. Je kunt nu een volgende plek toevoegen, of later terugkomen (via de knop rechtsboven)',
            '3_title': 'Dank je! Je bijdrage geeft nu al waardevolle inzichten voor natuur en landschap',
            '3_text': 'Nog één plek toevoegen maakt je kaart compleet — maar je kunt ook later verdergaan (via de knop rechtsboven)',
            '4_title': 'Geweldig — je persoonlijke kaart is compleet!',
            '4_text': 'Je bijdrage helpt onderzoekers en beheerders beter begrijpen welke plekken mensen willen behouden en beschermen. We gaan nu bijna het overzicht van je plekken zien. Eerst nog een vraag over mogelijke financiële steun aan je gebieden.'
        } */
        finished: {
          '1_title': 'Dank je! Je eerste plek staat op de kaart',
          '1_text': 'Alleen al deze bijdrage helpt beter begrijpen welke natuurgebieden mensen waarderen.',
          '2_title': 'Mooi — je persoonlijke kaart begint vorm te krijgen',
          '2_text': 'Met elke plek help je beter zichtbaar maken wat bescherming verdient.',
          '3_title': 'Dank je! Je bijdrage geeft nu al waardevolle inzichten voor natuur en landschap',
          '3_text': 'Nog één plek toevoegen maakt je kaart compleet.',
          '4_title': 'Geweldig — je persoonlijke kaart is compleet!',
          '4_text': 'Je bijdrage helpt onderzoekers en beheerders beter begrijpen welke plekken mensen willen behouden en beschermen. We gaan nu bijna het overzicht van je plekken zien. Eerst nog een vraag over mogelijke financiële steun aan je gebieden.'
        }
      },
      _edit: {
        title: 'Pas gebied aan'
      },
      welcome: {
        title: 'Gebieden tekenen en vragen beantwoorden',
        subtitle: 'Markeer vier natuurplekken op verschillende schalen en vertel waarom ze belangrijk voor je zijn.',
        sheet_text: 'Bekijk hieronder het overzicht. Druk op Volgende om je eerste gebied te tekenen in de buurt.',
        how_it_works_title: 'Wat je per niveau doet',
        step_draw: 'Markeer een gebied op de kaart',
        step_questions: 'Beantwoord vragen over je plek',
        step_next_level: 'Herhaal voor 4 schalen',
        journey_title: 'Vier schalen, vier plekken',
        video_caption: 'Korte uitleg over het tekenen van een gebied'
      },
      welcome_v3: {
        greeting: 'Welkom bij Greenmapper Friends',
        title: 'Markeer je natuurplek',
        intro: 'Markeer plekken met groen, water of landschap die je aantrekkelijk, waardevol of belangrijk vindt.',
        levels_title: 'Vier schalen',
        levels_intro: 'Op elk niveau kies je één plek.',
        checklist_title: 'Wat je per niveau doet',
        step_draw: 'Teken de plek als een gebied op de kaart.',
        step_adjust: 'Pas de vorm aan en bevestig het gebied.',
        step_questions: 'Beantwoord enkele vragen over waarom deze plek belangrijk voor je is.',
        step_repeat: 'Herhaal deze stappen voor het volgende schaalniveau.',
        repeat_hint: 'Je begint in je buurt. Na de vragen ga je door naar regio, land en wereld.',
        start_btn: 'Start met Buurt'
      },
      welcome_v4: {
        title: 'Markeer je natuurplek',
        title_next: 'Volgende plek: {level}',
        intro: 'Markeer plekken met groen, water of landschap die je aantrekkelijk, waardevol of belangrijk vindt.',
        intro_next: 'Ga verder met {level}. Markeer een plek met groen, water of landschap die je aantrekkelijk, waardevol of belangrijk vindt.',
        levels_title: 'Vier schalen',
        checklist_title: 'Wat je per niveau doet',
        start_badge: 'Start',
        now_badge: 'Nu',
        done_badge: 'Klaar',
        progress: 'Plek {current} van 4',
        start_btn: 'Start met {level}',
        continue_btn: 'Ga verder met {level}'
      }
    },
    edit_area: {
      title: 'Pas gebied aan'
    },
    funding: {
      title: 'Virtual Nature & Community funds',
      nav_intro: 'Introductie',
      nav_amount: 'Hoeveelheid',
      nav_locations: 'Locaties',
      nav_objectives: 'Doeleinden',
      nav_finalize: 'Einde',
      intro1: 'Hallo!',
      intro2: 'Dank je wel voor je deelname aan het Greenmapper-experiment over natuurfinanciering.',
      intro3: 'In dit onderdeel gebruik je het <b>Virtueel Natuur- en Gemeenschapsfonds</b>. Je laat zien hoe je een <b>denkbeeldig</b> jaarlijks natuurbudget zou verdelen — <b>zonder echt te betalen</b>. Samen met andere deelnemers geeft dit beheerders en beleidsmakers inzicht in wat mensen belangrijk vinden.',
      intro4: '<h6>Hoe het werkt in 3 stappen:</h6>',
      step1: 'Bevestig je totale natuurbudget',
      step2: 'Verdeel over je 4 gebieden',
      step3: 'Verdeel per gebied over doelen: biodiversiteit, landschap, duurzaam ondernemen, cultuur en anders',
      caption: 'Stam = gebied • Takken = doelen • Appels = voorbeelden van projecten.',
      intro5: '<b>Praktisch</b>: 5–8 min • anoniem • geen goede/foute antwoorden.',
      intro6: 'Als dank <b>doneren wij €5 aan natuur op Texel</b> na afronding van dit onderdeel.',
      amount1: 'Virtueel financieringsbedrag',
      amount2: 'Wat zou jij — als het echt kon — per jaar willen besteden aan jouw favoriete natuurgebieden? Het gaat om een fictief bedrag, maar probeer een keuze te maken die voor jou realistisch aanvoelt.',
      amount3: 'Vul hieronder je (virtuele) jaarlijkse natuurbudget in.',
      amount4: 'Kun je kort toelichten waarom je voor dit bedrag hebt gekozen? Bijvoorbeeld wat je belangrijk vindt om te steunen, of hoe je dit bedrag hebt bepaald.',
      amount5: 'jaarlijks budget',
      max: 'Maximun bedrag 5000 euro',
      min: 'Minimun bedrag 1 euro',
      locations1: 'Verdeel je budget over je favoriete natuurgebieden',
      locations2: 'Geef aan hoe jij je gekozen (virtuele) budget zou verdelen over de Virtuele Natuur- en Gemeenschapsfondsen van jouw favoriete natuurgebieden.',
      locations3: 'Kun je kort toelichten hoe je jouw verdeling hebt gemaakt? Waarom heb je ervoor gekozen om het zo te verdelen?',
      objectives1: 'Budget verdeling over de financieringsdoeleinden',
      objectives2: 'Hier zie je jouw verdeling over de Virtuele Natuur- en Gemeenschapsfondsen voor jouw gekozen gebied. Je kunt dit doen voor je favoriete gebieden in jouw buurt, regio, land en wereldwijd. Geef aan hoe jij je budget zou verdelen over de vier doelen:',
      objectives2a: 'Wil je iets steunen dat niet binnen deze categorieën past? Schrijf dat dan onderaan bij ‘Anders namelijk...’ en geef er een deel van je budget aan.',
      objectives3: 'Kun je kort toelichten hoe je jouw verdeling hebt gemaakt? Waarom heb je ervoor gekozen om het zo te verdelen?',
      biodiversity_title: 'Behoud van biodiversiteit',
      biodiversity_text: 'Een rijke biodiversiteit ondersteunt het functioneren van ecosystemen en is cruciaal voor het ondersteunen van al het leven op aarde. Projecten voor biodiversiteitsbehoud hebben als doel om de biodiversiteitswaarden te verbeteren of te behouden, vaak in een lokale context. Dergelijke projecten kunnen gericht zijn op het verbeteren van de bodem- en waterkwaliteit of bijvoorbeeld het plaatsen van nestkasten voor vogels.',
      ALC_title: 'Landschapskwaliteit en uitzicht',
      ALC_text: 'Een aantrekkelijk landschapsaangezicht heeft betrekking op het uitzicht en het genieten van een landschap. Een dergelijk project kan gaan over het beschermen of herstellen van landschapselementen zoals heggen, het opnieuw ‘verwilderen’ van het landschap of het aanleggen van wandel- of fietsroutes door het landschap.',
      SUSBUS_title: 'Duurzaam ondernemen',
      SUSBUS_text: 'Duurzame bedrijven voeren hun economische activiteiten uit zonder negatieve effecten voor hun (lokale) omgeving te veroorzaken. Duurzame bedrijfsprojecten kunnen betrekking hebben op de overgang van een conventionele boerderij naar biologische of natuurinclusieve landbouw. Het kan ook verwijzen naar het stichten van een netwerk van lokale bedrijven en organisaties die op geïntegreerde wijze afval en vervuiling verminderen.',
      finalize1: '<b>Bedankt!</b><br> Dank je voor je deelname aan het onderzoek naar natuurfinanciering van de Rijksuniversiteit Groningen. Je antwoorden zijn waardevol. Klik op <b>Opslaan</b> om ze vast te leggen.',
      finalize1A: '<b>Hoera!!</b><br> Je hebt €10,- verdiend voor natuurprojecten op Texel. Dank je — jouw bijdrage helpt ons begrijpen hoe mensen natuur willen steunen.',
      finalize1B: '<b>Wat gebeurt er nu?</b><br> Je gaat naar de Greenmapper Friends-community ‘Nationaal Park Duinen van Texel’ voor deel 3. Daar beoordeel je zes echte financieringsverzoeken. Geef per project aan of je het steunt en waarom.\n' + 'Je eigen bijdrage is fictief, maar de donaties van €10,- en €5,- namens jou zijn echt.',
      finalize1C: '<b>Extra beloning voor Texel</b><br> Reageer je op alle zes verzoeken? Dan doneert Greenmapper nog eens €5,- extra. Elke reactie telt! Na het reageren op alle zes verzoeken loot je automatisch mee om de prijs.',
      finalize2: 'In de volgende sectie zie je alle pledges staan . Je moet op elke pledge drukken en aangeven of je wilt pledgen ja of nee. En daarna de volgende pledge selecteren ',
      cultural_title: 'Cultuur en gemeenschapsleven',
      cultural_text: 'Natuurgebieden kunnen ook een cultureel erfgoed of andere culturele aspecten bevatten. Bijvoorbeeld als er historische gebouwen of monumenten aanwezig zijn, of als er bepaalde culturele evenementen mee verbonden zijn. Culturele projecten hebben betrekking tot de organisatie van (muzikale) evenementen, educatieve excursies of het behoud van landgoederen.',
      other_title: 'Anders',
      other_text: 'Wilt u iets anders financieren in uw favoriete natuurgebied, maar werd dit hierboven niet genoemd? Beschrijft u dit alstublieft zelf! U kunt deze schuifregelaar gebruiken om aan te geven hoeveel van uw budget u eraan wilt toewijzen. Dit is niet verplicht, alleen als u denkt aan iets dat niet binnen de eerder genoemde financieringsdoelen valt.',
      placeholder: 'Anders namelijk..'
    }
  },
  drawer: {
    area_section: 'Ontdekken',
    my_section: 'Mijn overzicht',
    other_section: 'Anders',
    edit_funding: 'Mijn Natuurbudget',
    per_year: '/jaar',
    messages: 'Berichten'
  },
  mail: {
    inbox: 'Inbox',
    outbox: 'Outbox',
    compose: 'Opstellen'
  },
  gender: {
    male: 'man',
    female: 'vrouw',
    other: 'anders'
  },
  education: {
    1: 'Basisonderwijs',
    2: 'Middelbaar onderwijs',
    3: 'Opleiding zonder diploma',
    4: 'MBO',
    5: 'HBO',
    6: 'Universitaire Bachelor',
    7: 'Universitaire Master',
    8: 'Doctoraat'
  },
  texel: {
    'continue-funding-1': 'U heeft zich onlangs geregistreerd voor Greenmapper Friends. Dank voor uw bereidheid deel te nemen aan dit onderzoek over financiële ondersteuning voor de natuur. Naast dat uw antwoorden waardevol zijn voor onderzoek, doneren wij per afgeronde deelname €15 aan natuurprojecten op Texel (max €2,000). Het experiment duurt tussen de 5 en 10 minuten. Zorgt u er alstublieft voor dat u reageert op alle virtuele financieringsverzoeken in het tweede deel van het onderzoek om afronding compleet te maken.',
    'continue-funding-2': 'Klik op “verder” om naar de introductie van het onderzoek te worden geleid.',
    'continue-funding-3': 'Wij willen u hartelijk danken voor uw waardevolle deelname aan het Greenmapper Friends platform.',
    'continue-register-1': 'U heeft onlangs het registratieproces voor Greenmapper Friends gestart, maar nog niet afgerond. Dank voor uw bereidheid uw registratieproces af te maken. Uw input over uw favoriete natuur is van groot belang voor onderzoekers en beleidsmakers.',
    'continue-register-2': 'Klik op “verder” om uw registratieproces te hervatten.',
    'continue-register-3': 'Wij willen u hartelijk danken voor uw waardevolle deelname aan het Greenmapper Friends platform.'
  },
  video: {
    'draw_popup_title_1': 'Buurt',
    'draw_popup_subtitle_1': 'Binnen 2km van huis',
    'draw_popup_text_1': 'Deze kaart laat een gebied van 2km rondom uw woonplek zien. Markeer een natuur-gerelateerde plek binnen deze 2km, die voor u aantrekkelijk, waardevol of belangrijk is. Weet u geen plek binnen de 2km cirkel, markeer dan een gebied zo dicht mogelijk erbij.',
    'draw_popup_title_2': 'Regio',
    'draw_popup_subtitle_2': 'Binnen 20km van huis',
    'draw_popup_text_2': 'Deze kaart laat een gebied van 20km rondom uw woonplek zien. Markeer een natuur-gerelateerde plek binnen deze 20km die voor u aantrekkelijk, waardevol en belangrijk is.',
    'draw_popup_title_3': 'Land',
    'draw_popup_subtitle_3': 'Heel het land',
    'draw_popup_text_3': 'Deze kaart laat een kaart van Nederland zien. Markeer een natuur-gerelateerde plek op deze kaart die voor u aantrekkelijk, waardevol of belangrijk is.',
    'draw_popup_title_4': 'Wereld',
    'draw_popup_subtitle_4': 'Wereldwijd',
    'draw_popup_text_4': 'Deze kaart laat een kaart van de wereld zien. Markeer een natuur-gerelateerde plek op deze kaart die voor u aantrekkelijk, waardevol of belangrijk is. Weet u geen plekken ver weg, dan kunt u hier ook nóg een plek in uw eigen land markeren.',
    'draw_popup_video': 'Hieronder ziet u een korte video (30s) over hoe je een gebied tekent.',
    'step1_helper': 'Sleep de kaart zodat jouw aantrekkelijke plek helemaal in de heldere cirkel past. Zoom tot de cirkel de plek volledig dekt.',
    'step2_helper': 'Ziet het er goed uit? Ga verder — of sleep optioneel de punten zodat de vorm je plek beter dekt.',
    'clamp_hint_default': 'Dit blijft binnen {distance}. Bij de volgende vraag mag het verder.',
    'scale_badge_radius': 'Binnen {distance} van thuis',
    'scale_badge_full': 'Op de kaart van {name}',
    'level_up_toast': 'Gebied vergroot naar {distance}'
  },
  pbl: {
    /* 'draw_popup_title_1': 'Buurt',
    'draw_popup_subtitle_1': 'Schaal: 2km',
    'draw_popup_text_1': 'Deze kaart laat een gebied van 2km rondom uw woonplek zien. Markeer een natuur-gerelateerde plek binnen deze 2km, die voor u aantrekkelijk, waardevol of belangrijk is. Weet u geen plek binnen de 2km cirkel, markeer dan een gebied zo dicht mogelijk erbij.',
    'draw_popup_title_2': 'Leefomgeving',
    'draw_popup_subtitle_2': 'Schaal: 20km',
    'draw_popup_text_2': 'Deze kaart laat een gebied van 20km rondom uw woonplek zien. Markeer een plek binnen deze 20km die voor u aantrekkelijk, waardevol en belangrijk is.',
    'draw_popup_title_3': 'Land',
    'draw_popup_subtitle_3': 'Schaal: heel Nederland',
    'draw_popup_text_3': 'Deze kaart laat een kaart van Nederland zien. Markeer een plek op deze kaart die voor u aantrekkelijk, waardevol of belangrijk is.',
    'draw_popup_title_4': 'Wereld',
    'draw_popup_subtitle_4': 'Schaal: wereldwijd',
    'draw_popup_text_4': 'Deze kaart laat een kaart van de wereld zien. Markeer een plek op deze kaart die voor u aantrekkelijk, waardevol of belangrijk is.', */
    '1_title': 'Geef een titel die het gebied weergeeft',
    '2_description': 'Omschrijf in uw eigen woorden wat dit gebied aantrekkelijk, waardevol of belangrijk voor je maakt. Gebruik zoveel woorden als u zelf wilt.',
    '3_rate': 'Waardeer dit gebied.',
    act_fun: '<b>Iets doen voor je plezier </b>(bv. wandelen, zwemmen, de hond uitlaten)',
    act_sport: '<b>Sporten</b> (bv. fietsen, mountainbiken, vissen)',
    act_meet: '<b>Naasten en bekenden ontmoeten</b> (bv. afspreken met vrienden, picknicken, spelen met de kinderen)',
    act_spot: '<b>Natuur of landschap bekijken</b> (bv. vogels spotten, planten of dieren bekijken)',
    act_gather: '<b>Voedsel plukken of jagen</b> (bv. bessen of kruiden plukken, jagen op wild)',
    act_work: '(Vrijwilligers)<b>werk</b> (bv. rondleidingen geven, bomen planten, meedoen aan een vogeltelling, oogsten van landbouwproducten)',
    act_relax: '<b>Ontspannen</b> (bv. rust opzoeken, lezen)',
    act_outside: '<b>Naar buiten gaan</b> (bv. de frisse lucht, zon of schaduw opzoeken)',
    '7_title': 'Hieronder staan uitspraken over verschillende aspecten die belangrijk kunnen zijn als je denkt over de natuur in dit gebied in de toekomst. Geef aan hoeveel prioriteit elk aspect volgens u zou moeten hebben. ',
    '7_title_nav': 'Toekomst',
    'q_a': 'De natuur in dit gebied biedt <b>mogelijkheden</b> voor <b>buitenrecreatie</b> en sport',
    'q_b': 'Mensen kunnen <b>genieten van de schoonheid</b> van de natuur in dit gebied',
    'q_c': 'De natuur in dit gebied wordt <b>beschermd voor</b> het belang van de <b>natuur zelf</b>',
    'q_d': 'We blijven onze <b>morele verantwoordelijkheid</b> nemen om de natuur in dit gebied te beschermen',
    'q_e': 'De natuur in dit gebied wordt <b>beschermd, ongeacht</b> of dit <b>de mens</b> ten goede komt of niet',
    'q_f': 'De natuur in dit gebied draagt bij aan <b>economische groei</b> en <b><werkgelegenheid/b>',
    'q_g': 'De natuur in dit gebied biedt <b>mogelijkheden</b> om goederen <b>te oogsten</b> zoals hout, bessen, paddenstoelen of vis',
    'q_h': 'De natuur in dit gebied draagt bij aan <b>zingeving</b> van ons leven',
    'q_i': 'De natuur in dit gebied biedt <b>religieuze</b> en <b>spirituele</b> waarden of ervaringen',
    'q_j': 'Mensen vinden een gevoel van <b>verbondenheid met de natuur</b> in dit gebied',
    'q_k': 'Mensen kunnen zich <b>verbonden</b> voelen <b>met</b> de <b>bomen en dieren</b> in dit gebied',
    'q_l': 'De natuur in dit gebied biedt mogelijkheden om <b>bij</b> te <b>dragen aan</b> de <b>gezondheid</b> van mensen',
    pbl_prio_7: '7 de hoogste prioriteit',
    '8_title': 'Verantwoordelijkheid voor dit gebied',
    '8_title_nav': 'Verantwoordelijkheid',
    'people_title': 'Vind u dat <b>burgers</b> verantwoordelijk zijn voor dit gebied?',
    'local_title': 'Vindt u dat <b>lokale overheden</b> verantwoordelijk zijn voor dit gebied?',
    'federal_title': 'Vindt u dat de <b>Rijksoverheid</b> verantwoordelijk is voor dit gebied?',
    'business_title': 'Vindt u dat het <b>bedrijfsleven</b> verantwoordelijk is voor dit gebied?'
  }
};